const config = {
	DEV: {
		clientId: '6f87d793-21ad-44d3-8066-3615272f6f47',
		scopes: ['api://80c1df5c-6f2d-4d11-93fb-ee2d27c8d7be/Permission.Read'],
		redirectUri: 'https://entries-elsewhere-nuts-planned.trycloudflare.com/auth/callback',
	},
	DEMO: {
		clientId: '6f87d793-21ad-44d3-8066-3615272f6f47',
		scopes: ['api://80c1df5c-6f2d-4d11-93fb-ee2d27c8d7be/Permission.Read'],
		redirectUri: 'https://inquiry-system-test.pages.dev/auth/callback',
	},
	PRODUCTION: {
		clientId: '6f87d793-21ad-44d3-8066-3615272f6f47',
		scopes: ['api://80c1df5c-6f2d-4d11-93fb-ee2d27c8d7be/Permission.Read'],
		redirectUri: 'https://hotaimotor.svy.one/inquirySystem/auth/callback',
	},
}[process.env.NODE_ENV];

export const isEntraConfigured = Boolean(
	config.clientId && config.scopes[0],
);

export const msalConfig = {
	auth: {
		clientId: config.clientId,
		authority: 'https://login.microsoftonline.com/organizations',
		redirectUri: config.redirectUri,
	},
	cache: {
		cacheLocation: 'sessionStorage',
	},
};

export const loginRequest = {
	scopes: config.scopes,
};

export const systemId = 'SC';



// WEBPACK FOOTER //
// ./src/js/entraConfig.js